import React from "react";
import "../../../App.css";
import { NavigationContext } from "../../../NavigationContext";
import { AgGridReact } from "ag-grid-react";
import {
  ClientSideRowModelModule,
  ValidationModule,
  RowSelectionModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  RowStyleModule,
} from "ag-grid-community";
import { GRID_COLUMN_EMPTY_ICONS } from "../../../utils/Constants";
import PropTypes from "prop-types";
import { ROUTES } from "../../../config/routes";
import { colors } from "../../../config/colors";
import { ProductAGgridStyled } from "../styled";
import { PlainDeleteLogo } from "../../../assets/icons";
import { Button } from "react-bootstrap";

class CateogoryAGgrid extends React.Component {
  static contextType = NavigationContext;

  constructor(props) {
    super(props);
    this.isSchoolAdmin = localStorage.getItem("role") === "SCHOOLADMIN";
    this.onGridReady = this.onGridReady.bind(this);
    this.state = {
      columnDefs: [
        {
          headerName: "Category Name",
          field: "labelEn",
          cellDataType: "string",
          icons: GRID_COLUMN_EMPTY_ICONS,
          flex: 0.8,
        },
        // {
        //   headerName: "Category (ENUM)",
        //   field: "name",
        //   sortable: true,
        //   filter: true,
        //   cellDataType: "string",
        //   icons: GRID_COLUMN_EMPTY_ICONS,
        //   unSortIcon: true,
        //   flex: 2,
        // },
        {
          headerName: "Actions",
          field: "actions",
          cellRenderer: (params) => this.renderActionButtons(params),
          icons: GRID_COLUMN_EMPTY_ICONS,
          flex: 0.2,
          sortable: false,
          filter: false,
        },
      ],
      paginationPageSize: 10,
      rowData: this.props.categories || [],
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span class="ag-overlay-no-rows-center">No categories found</span>',
    };
  }

  renderActionButtons = (params) => {
    return (
      <div style={{ display: "flex",  alignItems: "center", height: "100%" }}>
        
        <Button
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.stopPropagation();
            this.onDeleteClick(params.data);
          }}
          title="Delete"
        >
          <PlainDeleteLogo />
        </Button>
      </div>
    );
  };

  onRowClicked = (params) => {
    // View mode - navigate to category details
    const categoryId = params.data.labelEn;
    this.context.navigateTo(`${ROUTES.CATEGORIES}/${categoryId}`);
  };

  onDeleteClick = (data) => {
    if (this.props.onDeleteCategory) {
      this.props.onDeleteCategory(data);
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  render() {
    return (
      <ProductAGgridStyled style={{ height: "564px" }}>
        <AgGridReact
          columnDefs={this.state.columnDefs}
          overlayLoadingTemplate={this.state.overlayLoadingTemplate}
          overlayNoRowsTemplate={this.state.overlayNoRowsTemplate}
          rowData={this.state.rowData}
          onGridReady={this.onGridReady}
          rowHeight={51}
          rowStyle={{
            borderBottom: `1px solid ${colors.border}`,
          }}
          // onRowClicked={this.onRowClicked}
          disableSelectionOnClick={true}
          modules={[
            ClientSideRowModelModule,
            ValidationModule,
            RowSelectionModule,
            TextFilterModule,
            NumberFilterModule,
            DateFilterModule,
            CustomFilterModule,
            RowStyleModule,
          ]}
        />
      </ProductAGgridStyled>
    );
  }
}

CateogoryAGgrid.propTypes = {
  categories: PropTypes.array,
  onDeleteCategory: PropTypes.func,
};

export default CateogoryAGgrid;